import { ScreenProfileDetail } from '@dms/screen'

export default ScreenProfileDetail
